const PlaceDetail = { side: "left" };

export default {
	PlaceDetail,
};
